import axios from 'axios' //引入axios
import router from '../router'
//import qs from 'qs' //引入qs，用来序列化post类型的数据，否则后端无法接收到数据
// let ip ="http://127.0.0.1:8099";
// let url = ip+'/api/client/';
// let ip ="http://8.142.118.165/"
// let url = ip+'server/api/';
// let urltianbao = ip+'server/tianbao/';
// let url = 'http://127.0.0.1:8099/api/client/';
// url = 'http://8.142.118.165/server/api/';
let urltb = 'http://127.0.0.1:9090/api/tianbao/';
let url = 'http://www.hbbk68.com/server/api/';
	url = 'https://www.51yhzy.com/server/api/';
  // url = 'http://127.0.0.1:8099/api/client/';
  urltb = 'https://www.51yhzy.com/tianbao/api/';
  // url = 'http://8.142.125.170/server/api/';
  // urltb = 'http://8.142.125.170/tianbao/api/';
  urltb = 'https://www.hbbk68.com/tianbao/api/';
  url = 'https://www.hbbk68.com/server/api/';
// urltb = url;


// 设置post请求头

axios.defaults.headers.post['Content-Type'] = 'application/json';

axios.defaults.withCredentials = false;//在跨域请求时，不会携带用户凭证；返回的 response 里也会忽略 cookie

//创建axios实例，请求超时时间为300秒

const instance = axios.create({

 timeout: 300000,

});

//请求和响应拦截可以根据实际项目需求进行编写

// 请求发起前拦截

instance.interceptors.request.use((config) => {

//这里可以对接口请求头进行操作 如：config.headers['X-Token'] = token

 //console.log("请求拦截",config);
  if(config.method=='post'){
    if(config.url.indexOf('collegeSun')!=-1||
    config.url.indexOf('majorSun')!=-1||
    config.url.indexOf('provincialTable')!=-1||
    config.url.indexOf('rulesPlan')!=-1||
    config.url.indexOf('scoreCollege')!=-1||
    config.url.indexOf('scoreInfoZy')!=-1||
    config.url.indexOf('scoreMajor')!=-1||
    config.url.indexOf('queryAllByLimitScoreInfo')!=-1||
    config.url.indexOf('scoreRank')!=-1){
      config.url = urltb+config.url
    } else {
      config.url = url+config.url
    }

    if(config.url.indexOf('login')==-1){
      if(localStorage.getItem("userId")!=null&&localStorage.getItem("userId")!=''){
        // config.headers.id = localStorage.getItem("userId")
      }
      if(localStorage.getItem("userToken")!=null&&localStorage.getItem("userToken")!=''){
        config.headers.Authorization = 'Bearer '+localStorage.getItem("userToken")
      }
    }
  }
 return config;

}, (error) => {
 // Do something with request error
 return Promise.reject(error)
})

// 响应拦截（请求返回后拦截）

instance.interceptors.response.use(response => {

 //console.log("响应拦截",response.data);
if(response.data.excepStr!=""){
}
 return response.data;

}, error => {

 console.log('catch', error)
 if(JSON.stringify(error).indexOf('401')!=-1){
   router.push('/login')
 }
 return Promise.reject(error)

})

//按照请求类型对axios进行封装

const $http={

 get(http){

	return instance.get(http)

 },

 post(http){
  http.data.dev='PC'
	return instance.post(http.url,http.data)

 },

}

export {$http}



// WEBPACK FOOTER //
// ./src/service/service.js